<template>
        <div class="loading" v-show="isLoading">
            <div class="spinner-border  text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
        </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.loading;
            },
        }
    }
</script>

<style scoped lang="scss">
    .loading{
        position: fixed;
        top:0px;
        bottom: 0px;
        left:0px;
        right:0px;
        background-color: rgba(0,0,0,.3);
        z-index:9999;

        .spinner-border{
            width:32px;
            height:32px;
            position: absolute;
            top:50%;
            left:calc(50% - 16px);
        }
    }
</style>